import { Navigate, Route, Routes } from 'react-router-dom';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { Register } from './components/register/register';
import CompanySignUp from './components/company-sign-up/company-sign-up';
import ActivateAccount from './components/activate-account/activate-account';
import Activate from './components/activate/activate';
import SetPassword from './components/set-password/set-password';
import SendEmailSuccess from './components/send-email-success/send-email-success';
import { Logout } from './components/logout/logout';
import { Authorize } from './components/authorize/authorize';
import { MainLayout } from './components/main-layout/main-layout';
import { ForgotPassword } from './components/forgot-password/forgot-password';
import { NewUser } from './components/new-user/new-user';
import { environment } from '../environments/environment';

export function App() {
  return (
    <GoogleReCaptchaProvider reCaptchaKey={environment.recaptchaSiteKey}>
      <Routes>
        <Route
          path={'/'}
          element={<Navigate to={'/authorize'} replace={true} />}
        />
        <Route path={'/authorize'} element={<Authorize />} />
        <Route element={<MainLayout />}>
          <Route path={'/register'} element={<Register />} />
          <Route path={'/password'}>
            <Route path={'update'} element={<SetPassword />}></Route>
          </Route>
          <Route path={'/verify-email'} element={<SendEmailSuccess />} />
          <Route path={'/forgot-password'} element={<ForgotPassword />} />
          <Route path={'/activate-account'} element={<ActivateAccount />} />
          <Route path={'/activate'} element={<Activate />} />
          <Route path={'/activate/new-company'} element={<CompanySignUp />} />
          <Route path={'/new-user'} element={<NewUser />} />
        </Route>
        <Route path={'/v2'}>
          <Route path={'logout'} element={<Logout />} />
        </Route>
      </Routes>
    </GoogleReCaptchaProvider>
  );
}

export default App;
